/**
 * Topbar — StreamBridge brand logo + top-right icon cluster.
 *
 * Sits at the top of the Le Vanilla shell. Config is open for future
 * customisation (hide nav items, swap brand link target) but v1 just
 * renders the canonical platform chrome.
 */

import { LogIn } from 'lucide-react'
import { PlayLogo } from '@/components/brand/PlayLogo'
import { registerPrimitive, type PrimitiveProps } from '../../layout'

export function Topbar(_: PrimitiveProps) {
  return (
    <header className="lv-topbar">
      <a className="lv-brand" href="/" aria-label="StreamBridge home">
        <PlayLogo />
      </a>
      <div className="lv-topbar-right">
        <a className="lv-top-icon" href="/login" aria-label="Log in to StreamBridge" title="Log in to StreamBridge">
          <LogIn aria-hidden="true" />
        </a>
      </div>
    </header>
  )
}

registerPrimitive('Topbar', Topbar)
